const NO_CALCULABLE_OFFERS = 'No hay tarifas autorizadas que se hayan podido calcular para estos datos';
const PENDING_ADAPTATIONS = new Set([
    'Hay cargos adicionales cuya fórmula todavía no está soportada',
    'La fórmula indexada de Neuro necesita un adaptador específico antes de calcularla',
    'Hay componentes adicionales de energía o potencia pendientes de adaptar',
    'Esta tarifa exige un margen mínimo que todavía necesita adaptación',
    'La fórmula de compensación de excedentes necesita adaptación',
]);

export default function invoiceFailureMessage(failure) {
    // Only explain a limitation when the returned reasons establish it. A missing
    // catalog, invalid input or an unavailable service must keep its own message.
    if (failure.message !== NO_CALCULABLE_OFFERS || !failure.tariffErrors?.length) return failure.message;
    if (failure.tariffErrors.every(item => PENDING_ADAPTATIONS.has(item.error))) {
        return 'Neuro ha devuelto tarifas autorizadas, pero el comparador todavía no admite sus cargos o fórmulas. No se ha podido calcular ninguna oferta.';
    }
    return 'Neuro ha devuelto tarifas autorizadas, pero no se ha podido calcular ninguna oferta. Consulta los motivos en el detalle.';
}
